module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_vm._v("\n    Loading . . .\n  ")]) : _vm._e(), _vm._v(" "), (_vm.noResults) ? _c('div', [_vm._v("No results, try expanding you search query")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "map",
    staticClass: "SquadMap",
    attrs: {
      "id": "SquadMap"
    }
  }, [_c('map-popup-squad', {
    ref: "popup",
    attrs: {
      "zipcode": _vm.popupData.zip,
      "distance": _vm.popupData.distance,
      "squads": _vm.squadsData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e34c518","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/squad-map.vue
// module id = 345
// module chunks = 0